// :popover-open throws in selector engines that don't know it (jsdom)
export function isPopoverShown(element: HTMLElement): boolean {
  try {
    return element.matches(':popover-open');
  } catch {
    return false;
  }
}

// Hides the popover if it is showing. Returns true if so.
export function hidePopover(element: HTMLDivElement): boolean {
  if (isPopoverShown(element)) {
    element.hidePopover();
    return true;
  } else {
    return false;
  }
}
